export const name = 'menu';

const menuWrapper = document.getElementById( 'primary-menu-wrapper' );
const menuIcon = document.getElementById('menu-icon');
const menuButton = document.getElementById('primary-menu-button');

function hideOnClickOutside(menuSelector, ignoreSelector) {
    const outsideClickListener = event => {
        // Button that triggers the menu could live outside the wrapper, ignore it
        if( event.target.matches(ignoreSelector) ) {
            return;
        }

        // Ignore clicks inside our menu
        if ( event.target.closest(menuSelector) === null ) {
            // Toggle menu and remove listener so we don't keep toggling menu when it's closed
            toggleMenu(menuWrapper);
            document.removeEventListener('click', outsideClickListener);
        }
    };

    document.addEventListener('click', outsideClickListener);
}

function toggleMenu(wrapperElem) {
    console.log(wrapperElem.classList);
    wrapperElem.classList.toggle('toggled');
    menuButton.getAttribute('aria-expanded') === 'true' ? menuButton.setAttribute('aria-expanded', 'false') : menuButton.setAttribute('aria-expanded', 'true')
    menuIcon.classList.toggle('fa-times-circle');
    menuIcon.classList.toggle('fa-bars');
}


export function setupNav() {

    if ( 'querySelector' in document && 'addEventListener' in window ) {

        menuButton.addEventListener('click', function() {
            toggleMenu(menuWrapper);
            hideOnClickOutside('#primary-menu-wrapper', '.menu-button, #menu-icon');
        });

        const allMenuItems = menuWrapper.querySelectorAll( '#primary-menu > ul > li .menu-item' );
        for ( let i = 0; i < allMenuItems.length; i++ ) {
            if (allMenuItems[i].children.length > 1) {
                allMenuItems[i].firstChild.lastChild.hidden = false;
                allMenuItems[i].firstChild.lastChild.addEventListener('click', function(event) {
                    const subMenu = event.target.closest('li').querySelector('.sub-menu');
                    const menuButton = event.target.closest('button');

                    subMenu.toggleAttribute('hidden');
                    menuButton.getAttribute('aria-expanded') === 'true' ? menuButton.setAttribute('aria-expanded', 'false') : menuButton.setAttribute('aria-expanded', 'true')
                    menuButton.firstChild.classList.toggle('fa-minus-circle');
                    menuButton.firstChild.classList.toggle('fa-plus-circle');
                });
            }
        }

        const allSubmenus = menuWrapper.querySelectorAll( '#primary-menu > ul > li > ul > li .sub-menu' );
        for ( let i = 0; i < allSubmenus.length; i++ ) {
            const parentMenu = allSubmenus[i].closest('li');
            const subMenuButton = parentMenu.querySelector('button');

            allSubmenus[i].hidden = true;
            allSubmenus[i].id = parentMenu.id + '-submenu';
            subMenuButton.setAttribute('aria-controls', allSubmenus[i].id);
        }
    }
}